export const GET_NAVIGATION_MENU: string = "GET_NAVIGATION_MENU";
export const GET_NAVIGATION_MENU_SUCCESS: string = "GET_NAVIGATION_MENU_SUCCESS";
export const GET_NAVIGATION_MENU_FAILED: string = "GET_NAVIGATION_MENU_FAILED";

export const SET_NAVIGATION_MENU: string = "SET_NAVIGATION_MENU";

export const UPDATE_NAVIGATION_MENU: string = "UPDATE_NAVIGATION_MENU";
export const UPDATE_NAVIGATION_MENU_SUCCESS: string = "UPDATE_NAVIGATION_MENU_SUCCESS";
export const UPDATE_NAVIGATION_MENU_FAILED: string = "UPDATE_NAVIGATION_MENU_FAILED";